import type { OrderPreference } from '../dnd-data';

export const calculateNestedItemPosition: CalculateNestedItemPosition = ({
	itemId,
	currentItems,
	currentOrder,
	getItemId,
}) => {
	let orderedItemIds: string[];

	if (currentOrder && currentOrder.length > 0) {
		const itemIds = currentItems.map((currentItem) => getItemId(currentItem));
		const orderedFromSidebar = currentOrder
			.filter((sidebarItem) => itemIds.includes(sidebarItem.menuId))
			.map((sidebarItem) => sidebarItem.menuId);

		const remainingIds = itemIds.filter((id) => !orderedFromSidebar.includes(id));
		orderedItemIds = [...orderedFromSidebar, ...remainingIds];
	} else {
		orderedItemIds = currentItems.map((currentItem) => getItemId(currentItem));
	}

	const itemIndex = orderedItemIds.indexOf(itemId);

	if (orderedItemIds.length <= 1) {
		return {
			positionType: 'only',
			canMoveUp: false,
			canMoveDown: false,
		};
	}

	if (itemIndex === 0) {
		return {
			positionType: 'first',
			canMoveUp: false,
			canMoveDown: true,
		};
	}

	if (itemIndex === orderedItemIds.length - 1) {
		return {
			positionType: 'last',
			canMoveUp: true,
			canMoveDown: false,
		};
	}

	return {
		positionType: 'middle',
		canMoveUp: true,
		canMoveDown: true,
	};
};

export type ItemPosition = 'only' | 'first' | 'last' | 'middle';

export interface PositionCapabilities {
	canMoveDown: boolean;
	canMoveUp: boolean;
	positionType: ItemPosition;
}

type CalculateNestedItemPosition = (args: {
	currentItems: unknown[];
	currentOrder: OrderPreference;
	getItemId: (item: unknown) => string;
	itemId: string;
}) => PositionCapabilities;
